module.exports = __webpack_public_path__ + "img/pg.35097449.svg";